module.exports = __webpack_public_path__ + "static/media/addOff.6197b63e.svg";